/**
 * @description 带占位和默认图回退的背景加载方式
 * @author wayou
 */

import React, { Component } from 'react';
import imageApi from '@umu/umu-image-handle';
import { BG_PLACEHOLDER } from '../../images';
import './UMUBg.scss';

interface IUMUBgProps {
    clsName: string; // 自定义类名
    bgSrc: string; // 图片地址
    fallbackSrc?: string; // 自定义默认图
    style?: { [name: string]: string | number }; // 外部自定义样式
}

interface IUMUBgState {
    defaultImgCls: string;
    bgStyle: {
        backgroundImage: string;
    };
}

class UMUBg extends Component<IUMUBgProps, IUMUBgState> {
    public static defaultProps: Partial<IUMUBgProps> = {
        clsName: '',
        bgSrc: '',
        fallbackSrc: BG_PLACEHOLDER,
        style: {},
    };

    private _isMounted: boolean = false;

    constructor(props: IUMUBgProps) {
        super(props);

        this.lazyloadImg = this.lazyloadImg.bind(this);

        const defaultBg = this.props.fallbackSrc || BG_PLACEHOLDER;

        this.state = {
            defaultImgCls: 'umu-img-default',
            bgStyle: {
                backgroundImage: 'url(' + defaultBg + ')',
            },
        };
    }

    public lazyloadImg() {
        this._isMounted = true;
        const img = new Image();
        img.onload = () => {
            if (!this._isMounted) {
                return;
            }
            this.setState({
                bgStyle: {
                    backgroundImage: 'url(' + imageApi.process(this.props.bgSrc) + ')',
                },
                defaultImgCls: '',
            });
        };
        img.src = this.props.bgSrc;
    }

    public UNSAFE_componentWillReceiveProps(nextProps: IUMUBgProps) {
        if (nextProps.bgSrc !== this.props.bgSrc) {
            this.lazyloadImg();
        }
    }

    public componentDidMount() {
        this.lazyloadImg();
    }

    public componentWillUnmount() {
        this._isMounted = false;
    }

    public render() {
        const props = this.props;
        const eleStyle = Object.assign({}, this.props.style, this.state.bgStyle);
        return (
            <div className={'umu-bg ' + this.state.defaultImgCls + ' ' + props.clsName} style={eleStyle}>
                {props.children}
            </div>
        );
    }
}

export default UMUBg;
